module.exports = ".text-placeholder-default {\n    color: #062b3e !important;\n  }\n\n  .margin-bottom-15{\n    margin-bottom: 15px !important;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/trending-research/trending-research.component.css
// module id = ./src/app/feature/main/roles-shared/components/trending-research/trending-research.component.css
// module chunks = main